export default function _paperPage() {
    /**
     * banner h1 heading
     * @const {string}
     */
    const paperPage = document.querySelector('.paper-page');
    /**
     * banner h1 heading
     * @const {string}
     */
    const pageHeading = document.querySelector('.page-banner__title');
    /**
     * selector to find content of the tab group
     * @const {string}
     */
    // const TAB_CONTENT_SELECTOR = '[data-tab-group-controlled-by]';
    /**
     * @const {string} - arrary of content panels
     */
    const contentPanels = document.querySelectorAll('.paperinformation');
    /**
     * content panel 1
     * @const {string}
     */
    const panel1 = contentPanels[0];
    /**
     * content panel 2 2
     * @const {string}
     */
    const panel2 = contentPanels[1];
    /**
     * tab button element selector
     * @const {string}
     */
    const TAB_NAVIGATION_SELECTOR_BUTTON = '[data-tab-group-control]';
    /**
     * arrary of tab button elements
     * @const {string}
     */
    const tabButtons = document.querySelectorAll(
        TAB_NAVIGATION_SELECTOR_BUTTON
    );
    /**
     * tab button element 1
     * @const {string}
     */
    const tabButton1 = tabButtons[0];
    /**
     * tab button element 2
     * @const {string}
     */
    const tabButton2 = tabButtons[1];
    /**
     * current breadcrumb
     * @const {string}
     */
    const breadCrumb = document.querySelector('.breadcrumb__list-item-current');
    /**
     * current URL
     * @const {string}
     */
    const urlHash = window.location.hash;

    function initialisePaperPage() {
        //   paper code extracted from header
        const paperCode = pageHeading.innerHTML.split(' ')[0];

        const paperTitle1 = panel1
            ? panel1.querySelector('.papertitle').innerHTML
            : null;
        const paperTitle2 = panel2
            ? panel2.querySelector('.papertitle').innerHTML
            : null;

        if (paperTitle1 && paperTitle2) {
            // change header and page title when clicking tab 1
            const setElements1 = (e) => {
                e.preventDefault();
                pageHeading.innerHTML = `${paperCode} ${paperTitle1}`;
                document.title = `${paperCode} ${paperTitle1}`;
                breadCrumb.innerHTML = `${paperCode} ${paperTitle1}`;
            };

            // change header and page title when clicking tab 2
            const setElements2 = (e) => {
                e.preventDefault();
                pageHeading.innerHTML = `${paperCode} ${paperTitle2}`;
                document.title = `${paperCode} ${paperTitle2}`;
                breadCrumb.innerHTML = `${paperCode} ${paperTitle2}`;
            };

            // add click event to tab 1
            tabButton1.addEventListener('click', (e) => {
                setElements1(e);
            });

            // add click event to tab 2 if tab 2 exists
            tabButton2.addEventListener('click', (e) => {
                setElements2(e);
            });

            // set header etc to tab 2 details if refreshed on tab 2
            // or set to tab 1 details by defualt
            const initialiseElements = function () {
                const tab2Year = Number(
                    tabButton2.dataset.tabGroupControl.replace(/\D/g, '')
                );

                if (urlHash === '') {
                    window.addEventListener('load', (e) => {
                        tabButton2.click(e);
                    });
                } else if (urlHash.includes(tab2Year.toString())) {
                    tabButton2.click();
                } else tabButton1.click();
            };

            initialiseElements();
        }
    }

    const tab2Exists = !!tabButton2;
    const paperPageExists = !!paperPage;

    // If the module exists, do whatever we need to
    if (tab2Exists && paperPageExists) {
        initialisePaperPage();
    }
}

_paperPage();
